



































































































import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import NumberValue from '@/tasks/components/NumberValue.vue';
import {defineComponent} from '@vue/composition-api';
import STextarea from '@/common/components/STextarea.vue';

export default defineComponent({
  name: 'uOttawa1321Lab6Question3',
  components: {
    STextarea,
    NumberValue,
    StembleLatex,
    CalculationInput,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    const browserLanguage = navigator.language.split('-')[0]; // Extract the language code
    return {
      inputs: {
        volBromobenzene: null,
        massMg: null,
        massWaterNeeded: null,
        volWaterNeeded: null,
        calculations: null,
        language: browserLanguage === 'fr' ? 'fr' : 'en', // Set the initial language based on browser preference
      },
      calculations: [] as File[],
    };
  },
});
